module.exports = __webpack_public_path__ + "static/img/robot-title.4e037ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/robot-title.jpg
// module id = fOAG
// module chunks = 1